import { createSelector } from 'reselect';
import PaperFreeMonitoringPostSummaryColumns from '../../containers/PaperFreeMonitoringPostSummaryColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state =>
  state.reporting.PAPER_FREE_MONITORING_POST_900_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading = state =>
  state.reporting.PAPER_FREE_MONITORING_POST_900_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.PAPER_FREE_MONITORING_POST_900_SUMMARY.getDataFunction();

export const getColumns = createSelector(
  getData,
  state => state.userData.userType,
  PaperFreeMonitoringPostSummaryColumns,
);
